import { forwardRef, HTMLAttributes, ReactNode, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { ClipboardButton } from '../ClipboardButton/ClipboardButton';
import { ITextWithCopyStyles, textWithCopyStylesDefault } from './TextWithCopy.styles';

export enum TextWithCopyType {
  code = 'code',
  text = 'text',
}

interface ITextWithCopyClassNames {
  root: string;
  header: string;
  body: string;
  contents: string;
}

export interface ITextWithCopyProps extends IComponent<ITextWithCopyStyles>, HTMLAttributes<HTMLSpanElement> {
  text: string | undefined;
  type?: TextWithCopyType;
  header?: ReactNode | undefined;
  hasBorder?: boolean;
}

export const TextWithCopy = forwardRef((props: ITextWithCopyProps, ref: Ref<HTMLSpanElement>) => {
  const { styles, text, type = TextWithCopyType.text, className, header, hasBorder, ...elementProps } = props;
  const classNames = useClassNames<ITextWithCopyStyles, ITextWithCopyClassNames>(
    'TextWithCopy',
    textWithCopyStylesDefault,
    styles,
    className,
    !!header && 'has-header'
  );

  return (
    <span {...elementProps} ref={ref} className={classNames.root} data-test={props['data-test'] || 'text-with-copy'}>
      {header && <span className={classNames.header}>{header}</span>}
      <span className={classNames.body}>
        {type === TextWithCopyType.code ? (
          <code title={text} className={classNames.contents}>
            {text}
          </code>
        ) : (
          <span title={text} className={classNames.contents}>
            {text}
          </span>
        )}
        <ClipboardButton block={!hasBorder} content={text} />
      </span>
    </span>
  );
});
